import React from 'react';
import { Parallax } from 'react-parallax';
import TagSuggestion from '../TagSuggestion';
import { formatFloatNumber } from '~/utils/formatter';

const ILLUST_AC = 'illust_ac';
const PHOTO_AC = 'photo_ac';
const SILHOUETTE_AC = 'silhouette_ac';
const DESIGN_AC = 'design_ac';

const TagDetailCover = (props) => {
  let {
    backgroundImageUrl,
    keyword,
    searchNumber,
    serviceType,
    suggestedList,
    t,
  } = props;
  let title = '';
  let subTitle = '';
  keyword = keyword[0].toUpperCase() + keyword.substring(1);
  searchNumber = formatFloatNumber(searchNumber);
  switch (serviceType) {
    case ILLUST_AC:
      title = t('illust_detail_cover_title', { keyword, searchNumber });
      subTitle = t('illust_detail_cover_sub_title', { keyword, searchNumber });
      break;
    case PHOTO_AC:
      title = t('photo_detail_cover_title', { keyword, searchNumber });
      subTitle = t('photo_detail_cover_sub_title', { keyword, searchNumber });
      break;
    case SILHOUETTE_AC:
      title = t('silhouette_detail_cover_title', { keyword, searchNumber });
      subTitle = t('silhouette_detail_cover_sub_title', {
        keyword,
        searchNumber,
      });
      break;
    case DESIGN_AC:
      title = t('design_detail_cover_title', { keyword, searchNumber });
      subTitle = t('design_detail_cover_sub_title', { keyword, searchNumber });
      break;
  }
  return (
    <Parallax
      bgImage={backgroundImageUrl}
      strength={200}
      blur={20}
      renderLayer={() => <div className="tag-detail-cover-parallax-cover" />}
    >
      <section className="section-detail-cover">
        <div className="detail-cover-title">
          <span>{title}</span>
        </div>
        <h1>
          <span className="detail-cover-sub-title">{subTitle}</span>
        </h1>
        {suggestedList.length > 0 && <TagSuggestion tags={suggestedList} />}
        <style jsx global>
          {`
            .tag-detail-cover-parallax-cover {
              position: absolute;
              background: linear-gradient(
                0deg,
                transparent 0,
                rgba(0, 0, 0, 0.7)
              );
              width: 100%;
              height: 100%;
              top: 0;
            }

            .section-detail-cover {
              position: relative;
              color: #fff;
              background-repeat: no-repeat;
              background-position: center;
              background-size: cover;
              display: flex;
              justify-content: center;
              align-items: center;
              flex-direction: column;
              padding: 50px 0px;
            }
            .section-detail-cover .detail-cover-title {
              padding: 5px;
              font-size: 35px;
              font-weight: 400;
              text-align: center;
            }
            .section-detail-cover .detail-cover-sub-title {
              padding: 7px 25px;
              font-size: 20px;
              font-weight: 300;
              display: inline-block;
              text-align: center;
            }
            .section-detail-cover .bg-blur {
              position: 'absolute';
              background: 'linear-gradient(0deg, transparent 0, rgba(0, 0, 0, 0.49))';
              width: '100%';
              height: '100%';
              top: 0;
            }
          `}
        </style>
      </section>
    </Parallax>
  );
};

export default TagDetailCover;
